import { InjectionToken } from '@angular/core';
import { EMIEnvironment } from '@core/models/environment.models';

export const ENVIRONMENT: InjectionToken<EMIEnvironment> = new InjectionToken('ENVIRONMENT');
